import { lazy } from 'react';

const CustomPlanificationsTracingContract = lazy(() => import('./CustomPlanificationsTracingContract'));

export default CustomPlanificationsTracingContract;
